// Storage keys used across the application
export const LAST_SELECTED_INSTITUTION_KEY = "lastSelectedInstitution";
export const REQUEST_ABSENCETYPE_OTHER_UUID = "00000000-0000-0000-0000-000000000042";
export const REQUEST_ABSENCETYPE_OTHER_ID = -2;
